/**
 * Landing query for Safety Manager Function Logic Diagrams.
 *
 * For every `:FunctionLogicDiagram` it returns:
 *   - `diagram`    — the node itself
 *   - `solver`     — the owning `(:LogicSolver)-[:CONTAINS]->`
 *   - `site`       — `(:LogicSolver)-[:PART_OF]->(:Site)`
 *   - `pointCount` — distinct `[:CONTAINS]->(:SafetyPoint)` children
 *   - `implementedBy` — `(:ProtectiveFunction)-[:IMPLEMENTED_BY]->` this FLD
 *
 * Drained client-side via `drainCypherRows` to defeat the proxy's
 * silent auto-`LIMIT 100` cap.
 */
export const PLANT_FUNCTION_LOGIC_DIAGRAMS_CYPHER = `
            MATCH (fld:FunctionLogicDiagram)
            OPTIONAL MATCH (ls:LogicSolver)-[:CONTAINS]->(fld)
            OPTIONAL MATCH (ls)-[:PART_OF]->(site:Site)
            OPTIONAL MATCH (fld)-[:CONTAINS]->(sp:SafetyPoint)
            OPTIONAL MATCH (impl:ProtectiveFunction)-[:IMPLEMENTED_BY]->(fld)
            RETURN fld AS diagram,
                   ls AS solver,
                   site,
                   count(distinct sp) AS pointCount,
                   collect(distinct impl) AS implementedBy
            ORDER BY toLower(coalesce(fld.name, fld.id))
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `
